import jwtDecode from 'jwt-decode';
import Constants from './Constants';
import { createLogger } from './logging';

const logger = createLogger('utils/trustedDevices');

export const jwtDecodeWrapper = (token) => {
    let result;
    try {
        result = jwtDecode(token);
    } catch (e) {
        logger.error(`Invalid JWT token: ${token}`);
        result = {};
    }
    return result;
};

const currentTimestampInSeconds = () => Math.floor(Date.now() / 1000);

export const extractAccessToken = (response) => {
    let result = null;
    const { authorization } = response.headers;
    if (authorization) {
        const matches = authorization.match(Constants.BEARER_REGEX);
        result = matches && matches.length > 1
            ? matches[1]
            : null;
    }
    return result;
};

export const extractPrivileges = (accessToken) => {
    let result = [];
    if (accessToken) {
        result = jwtDecodeWrapper(accessToken).perms || [];
    }
    return result;
};

export const isValidToken = (accessToken) => {
    let result = false;
    if (accessToken) {
        result = jwtDecodeWrapper(accessToken).exp > currentTimestampInSeconds();
    }
    return result;
};

export const getSecondsToLogout = (accessToken) => {
    let result = 0;
    if (accessToken) {
        result = jwtDecodeWrapper(accessToken).exp - currentTimestampInSeconds();
    }
    return result;
};

export const getUserIdFromToken = (accessToken) => {
    let result = '';
    if (accessToken) {
        result = jwtDecodeWrapper(accessToken).sub;
    }
    return result;
};

export const getPasswordPolicyFromToken = (accessToken) => {
    let result = {};
    if (accessToken) {
        result = jwtDecodeWrapper(accessToken).passwordPolicy || {};
    }
    return result;
};

export const getUserNameFromToken = (accessToken) => {
    let result = '';
    if (accessToken) {
        result = jwtDecodeWrapper(accessToken).name;
    }
    return result;
};

export const getDaysToPasswordExpiration = (accessToken) => {
    let result = null;
    if (accessToken) {
        const passwordExpirationInSeconds = jwtDecode(accessToken).passwordExpires - currentTimestampInSeconds();
        result = passwordExpirationInSeconds && passwordExpirationInSeconds > 0
            ? Math.floor(passwordExpirationInSeconds / Constants.DAY_IN_SECONDS)
            : null;
    }
    return result;
};

export const isPreAuthentication = (accessToken) => {
    if (accessToken) {
        return jwtDecode(accessToken).preAuthentication;
    }

    return null;
};

export const isPasswordExpirationNonnegligible = (daysToPasswordExpiration) => (
    daysToPasswordExpiration !== null
        && daysToPasswordExpiration > Constants.PASSWORD_EXPIRATION_ERROR_DAYS
        && daysToPasswordExpiration <= Constants.PASSWORD_EXPIRATION_WARNING_DAYS
);

export const isPasswordExpirationCritical = (daysToPasswordExpiration) => (
    daysToPasswordExpiration !== null
        && daysToPasswordExpiration <= Constants.PASSWORD_EXPIRATION_ERROR_DAYS
);

export const isInternalUser = (accessToken) => {
    let result = false;
    if (accessToken) {
        result = jwtDecodeWrapper(accessToken).internal;
    }
    return result;
};
